import React from 'react';
import {
  arrayOf, bool, number, shape, string
} from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { LearnMoreShipping } from '../learn-more/LearnMoreShipping';
import { LearnMoreDelivery } from '../learn-more/LearnMoreDelivery';
import { LearnMoreReturns } from '../learn-more/LearnMoreReturns';
import { AttributeList } from '../attribute-list/AttributeList';
import './mobileCollectionInfo.scss';
import { getCareInstructions, getOtherDescriptors } from '../../helpers';

export const MobileCollectionInfo = ({ descriptiveAttributes, description, descriptors }) => {
  const careInstructions = getCareInstructions({ descriptors });
  const otherDescriptors = getOtherDescriptors({ descriptors, careInstructions });
  const hasAttributes = (descriptiveAttributes || []).length > 0;
  // default to fragments b/c overlay does not like `null`. (ie fix card)
  const { description: careDescription } = careInstructions || {};
  const descriptive = hasAttributes
    ? <AttributeList attributes={descriptiveAttributes} />
    : <></>;
  const care = careInstructions
    ? (
      <AttributeList
        heading={careInstructions.heading}
        attributes={careInstructions.descriptiveAttributes}
        careDescription={careDescription}
      />
    )
    : <></>;

  return (
    <>
      {(hasAttributes || careInstructions) && (
        <Card>
          <Card.Content title="Description &amp; Care" fade>
            {descriptive && descriptive}
            {!descriptive && care }
            <Card.Content.Overlay>
              {descriptive}
              {description && <p className="mobileCollectionInfo__description">{description}</p>}
              {otherDescriptors
              && (
                <>
                  {otherDescriptors.map((desc, descIndex) => {
                    return (
                      <AttributeList
                        key={descIndex}
                        attributes={desc.descriptiveAttributes}
                        heading={desc.heading}
                        description={desc.description}
                      />
                    );
                  })}
                </>
              )}
              {care}
            </Card.Content.Overlay>
          </Card.Content>
        </Card>
      )}
      <Card>
        <Card.Content title="Shipping &amp; Returns" fade>
          <LearnMoreShipping />
          <Card.Content.Overlay>
            <LearnMoreShipping />
            <LearnMoreDelivery />
            <LearnMoreReturns />
          </Card.Content.Overlay>
        </Card.Content>
      </Card>
    </>
  );
};

MobileCollectionInfo.displayName = 'MobileCollectionInfo';

MobileCollectionInfo.propTypes = {
  description: string,
  descriptiveAttributes: arrayOf(shape({
    bulleted: bool, // ignored :shrug:
    name: string, // ignored
    sequence: number,
    value: string
  })),
  descriptors: arrayOf(shape({
    description: string,
    heading: string
  }))
};

MobileCollectionInfo.defaultProps = {
  description: null,
  descriptiveAttributes: null,
  descriptors: null,
};
